import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import {
  CreateContactTypeFailure,
  CreateContactTypeRequest,
  CreateContactTypeSuccess,
  DeleteContactTypeFailure,
  DeleteContactTypeRequest,
  DeleteContactTypeSuccess,
  FetchContactTypeFailure,
  FetchContactTypeRequest,
  FetchContactTypeSuccess,
  FetchContactTypesFailure,
  FetchContactTypesRequest,
  FetchContactTypesSuccess,
  UpdateContactTypeFailure,
  UpdateContactTypeRequest,
  UpdateContactTypeSuccess,
} from './contact-types.actions'
import { ContactTypesService } from './contact-types.service'
import * as ContactTypesTypes from './contact-types.types'

@Injectable()
export class ContactTypesEffects {
  constructor(
    private actions: Actions,
    private contactTypesService: ContactTypesService,
    private router: Router,
  ) {}

  FetchContactTypes$ = createEffect(() =>
    this.actions.pipe(
      ofType(ContactTypesTypes.FETCH_CONTACT_TYPES_REQUEST),
      switchMap((action: FetchContactTypesRequest) => {
        return this.contactTypesService.fetchContactTypes(action.payload).pipe(
          map((result) => {
            return new FetchContactTypesSuccess(
              result.data.results,
              result.data.totalCount,
              result.data.filteredCount,
            )
          }),
          catchError((err, caught) => {
            return of(new FetchContactTypesFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  FetchContactType$ = createEffect(() =>
    this.actions.pipe(
      ofType(ContactTypesTypes.FETCH_CONTACT_TYPE_REQUEST),
      switchMap((action: FetchContactTypeRequest) => {
        return this.contactTypesService.fetchContactType(action.id).pipe(
          map((result) => {
            return new FetchContactTypeSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchContactTypeFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  DeleteContactType$ = createEffect(() =>
    this.actions.pipe(
      ofType(ContactTypesTypes.DELETE_CONTACT_TYPE_REQUEST),
      switchMap((action: DeleteContactTypeRequest) => {
        return this.contactTypesService.deleteContactType(action.id).pipe(
          switchMap((result) => {
            return [new DeleteContactTypeSuccess()]
          }),
          catchError((err, caught) => {
            return of(new DeleteContactTypeFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  CreateContactType$ = createEffect(() =>
    this.actions.pipe(
      ofType(ContactTypesTypes.CREATE_CONTACT_TYPE_REQUEST),
      switchMap((action: CreateContactTypeRequest) => {
        return this.contactTypesService.createContactType(action.payload).pipe(
          switchMap((result) => {
            this.router.navigate(['/admin/contact-types'])
            return [new CreateContactTypeSuccess()]
          }),
          catchError((err, caught) => {
            return of(new CreateContactTypeFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  UpdateContactType$ = createEffect(() =>
    this.actions.pipe(
      ofType(ContactTypesTypes.UPDATE_CONTACT_TYPE_REQUEST),
      switchMap((action: UpdateContactTypeRequest) => {
        return this.contactTypesService
          .updateContactType(action.id, action.payload)
          .pipe(
            switchMap((result) => {
              this.router.navigate(['/admin/contact-types'])
              return [
                new FetchContactTypeRequest(action.id),
                new UpdateContactTypeSuccess(),
              ]
            }),
            catchError((err, caught) => {
              return of(new UpdateContactTypeFailure({ error: err }))
            }),
          )
      }),
    ),
  )
}
